import { useTribeClient } from '@tribeplatform/react-sdk'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

import { AskAISettingsCard } from './AskAISettingsCard.js'
import { FederatedSearchCard } from './FederatedSearchCard.js'
import { OfficialResourceSpaces } from './OfficialResourceSpaces.js'
import { SearchSourcesCard } from './SearchSourcesCard.js'

export const SearchSettings = () => {
  const {
    config: { enableAiSearch: isAiSearchEnabled },
  } = useTribeClient()

  const { data: network } = useNetwork({
    ignorePlaceholderData: true,
    fields: {
      searchSettings: 'all',
    },
  })

  if (!network) {
    return null
  }

  return (
    <div className="flex flex-col space-y-5 max-w-3xl">
      <SearchSourcesCard searchSettings={network.searchSettings} />
      <OfficialResourceSpaces searchSettings={network.searchSettings} />
      {isAiSearchEnabled && <AskAISettingsCard />}
      <FederatedSearchCard />
    </div>
  )
}
